<template>
  <add-edit-dialog v-if="visible">
    <crm-panel title="公海规则设置">
      <div class="page-buttons">
        <crm-button :text="'保存'" @click="handleSave()"> </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCancel()"
        >
        </crm-button>
      </div>
      <el-form
        label-width="160px"
        ref="form"
        :model="form"
        class="add-edit-form"
      >
        <template v-for="item in ruleList">
          <el-form-item
            v-if="
              [
                'salesman_rule',
                'customer_count_rule',
                'apply_rate_rule',
              ].includes(item.ruleName)
            "
            :label="nameMap[item.ruleName]"
            :key="item.id"
          >
            <el-radio-group v-model="form[item.ruleName]['isLimited']">
              <el-radio :label="0">不限制</el-radio>
              <el-radio :label="1">限制</el-radio>
            </el-radio-group>
            <template v-if="form[item.ruleName]['isLimited'] == 1">
              <div
                class="input-custom"
                v-if="item.ruleName === 'salesman_rule'"
              >
                前业务员<el-input
                  type="number"
                  @keydown.native="channelInputLimit"
                  @keyup.native="
                    form[item.ruleName]['limitData'] = oninput(
                      form[item.ruleName]['limitData'],
                    )
                  "
                  v-model.number="form[item.ruleName]['limitData']"
                  size="small"
                ></el-input
                >天内不允许申请该客户
              </div>
              <div
                class="input-custom"
                v-if="item.ruleName === 'customer_count_rule'"
              >
                每个业务员最多保有<el-input
                  type="number"
                  @keydown.native="channelInputLimit"
                  @keyup.native="
                    form[item.ruleName]['limitData'] = oninput(
                      form[item.ruleName]['limitData'],
                    )
                  "
                  v-model.number="form[item.ruleName]['limitData']"
                  size="small"
                ></el-input
                >个客户
              </div>
              <div
                class="input-custom"
                v-if="item.ruleName === 'apply_rate_rule'"
              >
                每天最多申请<el-input
                  type="number"
                  @keydown.native="channelInputLimit"
                  @keyup.native="
                    form[item.ruleName]['limitData'] = oninput(
                      form[item.ruleName]['limitData'],
                    )
                  "
                  v-model.number="form[item.ruleName]['limitData']"
                  size="small"
                ></el-input
                >个公海客户
              </div>
              <div
                class="tip"
                v-if="
                  !form[item.ruleName]['limitData'] ||
                    form[item.ruleName]['limitData'] < 1 ||
                    (form[item.ruleName]['limitData'] > 99999 &&
                      form[item.ruleName]['isLimited'] == 1)
                "
              >
                <span>*</span>
                {{
                  nameMap[item.ruleName] +
                    '需要填写限制数量且数量应在 1 到 99999 之间'
                }}
              </div>
            </template>
          </el-form-item>
          <el-form-item
            v-else-if="item.ruleName === 'recover_rule'"
            :label="nameMap[item.ruleName]"
            :key="item.id"
          >
            <el-radio-group v-model="form[item.ruleName]['isLimited']">
              <el-radio :label="0">不自动回收</el-radio>
              <el-radio :label="1">自动回收</el-radio>
            </el-radio-group>
            <template v-if="form[item.ruleName]['isLimited'] === 1">
              <section v-for="child in list" :key="child.id">
                <div
                  class="input-custom list"
                  v-if="child.ruleName === 'visit_rule'"
                >
                  <el-checkbox
                    v-model="form[child.ruleName]['isLimited']"
                    :true-label="1"
                    :false-label="0"
                    >超过N天“无新建拜访（拜访记录）”的客户，由系统定时退回公海客户池</el-checkbox
                  >
                  <!-- v-if="form[child.ruleName]['isLimited'] === 1" -->
                  <div class="areaCheck">
                    <div class="item">
                      <span>选择不进入公海</span>
                      <div class="checkboxs">
                        <el-checkbox
                          :true-label="1"
                          :false-label="0"
                          v-model="form[child.ruleName]['isContract']"
                          >已签约客户</el-checkbox
                        >
                        <el-checkbox
                          :true-label="1"
                          :false-label="0"
                          v-model="form[child.ruleName]['isBusiness']"
                          >有商机客户</el-checkbox
                        >
                      </div>
                    </div>
                    <el-table
                      class="table"
                      :data="[child]"
                      border
                      style="width: 90%"
                    >
                      <el-table-column
                        fixed
                        prop="gmtModified"
                        label="客户"
                        width="200"
                        align="center"
                      >
                        <span>所有客户</span>
                      </el-table-column>
                      <el-table-column
                        prop="limitData"
                        align="center"
                        label="未拜访天数"
                      >
                        <el-input
                          type="number"
                          @keydown.native="channelInputLimit"
                          @keyup.native="
                            form[child.ruleName]['limitData'] = oninput(
                              form[child.ruleName]['limitData'],
                            )
                          "
                          v-model.number="form[child.ruleName]['limitData']"
                        ></el-input>
                      </el-table-column>
                    </el-table>
                    <div
                      class="tip"
                      v-if="
                        !form[child.ruleName]['limitData'] ||
                          form[child.ruleName]['limitData'] < 1 ||
                          (form[child.ruleName]['limitData'] > 99999 &&
                            form[child.ruleName]['isLimited'] === 1)
                      "
                    >
                      <span>*</span>
                      未拜访天数需要填写限制数量且数量应在 1 到 99999 之间
                    </div>
                  </div>
                </div>
                <div
                  class="input-custom list"
                  v-if="child.ruleName === 'business_rule'"
                >
                  <el-checkbox
                    v-model="form[child.ruleName]['isLimited']"
                    :true-label="1"
                    :false-label="0"
                    >超过N天“无新建商机”的客户，由系统定时退回公海客户池</el-checkbox
                  >
                  <!-- v-if="form[child.ruleName]['isLimited'] == 1" -->
                  <div class="areaCheck">
                    <div class="item">
                      <span>选择不进入公海</span>
                      <div class="checkboxs">
                        <el-checkbox
                          v-model="form[child.ruleName]['isContract']"
                          :true-label="1"
                          :false-label="0"
                          >已签约客户</el-checkbox
                        >
                        <!-- <el-checkbox
                          v-model="form[child.ruleName]['isBusiness']"
                          :true-label="1"
                          :false-label="0"
                          >有商机客户</el-checkbox
                        > -->
                      </div>
                    </div>
                    <el-table
                      class="table"
                      :data="[child]"
                      border
                      style="width: 90%"
                    >
                      <el-table-column
                        fixed
                        prop="date"
                        label="客户"
                        align="center"
                        width="200"
                      >
                        <span>所有客户</span>
                      </el-table-column>
                      <el-table-column
                        prop="limitData"
                        align="center"
                        label="未创建商机天数"
                      >
                        <el-input
                          type="number"
                          @keydown.native="channelInputLimit"
                          @keyup.native="
                            form[child.ruleName]['limitData'] = oninput(
                              form[child.ruleName]['limitData'],
                            )
                          "
                          v-model.number="form[child.ruleName]['limitData']"
                        ></el-input>
                      </el-table-column>
                    </el-table>
                    <div
                      class="tip"
                      v-if="
                        !form[child.ruleName]['limitData'] ||
                          form[child.ruleName]['limitData'] < 1 ||
                          (form[child.ruleName]['limitData'] > 99999 &&
                            form[child.ruleName]['isLimited'] === 1)
                      "
                    >
                      <span>*</span>
                      未创建商机天数需要填写限制数量且数量应在 1 到 99999 之间
                    </div>
                  </div>
                </div>
                <div
                  class="input-custom list"
                  v-if="child.ruleName === 'contract_rule'"
                >
                  <el-checkbox
                    v-model="form[child.ruleName]['isLimited']"
                    :true-label="1"
                    :false-label="0"
                    >超过N天“未签约”的客户，由系统定时退回公海客户池</el-checkbox
                  >
                  <!-- v-if="form[child.ruleName]['isLimited'] == 1" -->
                  <div class="areaCheck">
                    <div class="item">
                      <span>选择不进入公海</span>
                      <div class="checkboxs">
                        <!-- <el-checkbox
                          :true-label="1"
                          :false-label="0"
                          v-model="form[child.ruleName]['isContract']"
                          >已签约客户</el-checkbox
                        > -->
                        <el-checkbox
                          :true-label="1"
                          :false-label="0"
                          v-model="form[child.ruleName]['isBusiness']"
                          >有商机客户</el-checkbox
                        >
                      </div>
                    </div>
                    <el-table
                      class="table"
                      :data="[child]"
                      border
                      style="width: 90%"
                    >
                      <el-table-column
                        fixed
                        prop="date"
                        label="客户"
                        width="200"
                        align="center"
                      >
                        <span>所有客户</span>
                      </el-table-column>
                      <el-table-column
                        prop="limitData"
                        align="center"
                        label="未签约天数"
                      >
                        <el-input
                          type="number"
                          @keydown.native="channelInputLimit"
                          @keyup.native="
                            form[child.ruleName]['limitData'] = oninput(
                              form[child.ruleName]['limitData'],
                            )
                          "
                          v-model.number="form[child.ruleName]['limitData']"
                        ></el-input>
                      </el-table-column>
                    </el-table>
                    <div
                      class="tip"
                      v-if="
                        !form[child.ruleName]['limitData'] ||
                          form[child.ruleName]['limitData'] < 1 ||
                          (form[child.ruleName]['limitData'] > 99999 &&
                            form[child.ruleName]['isLimited'] === 1)
                      "
                    >
                      <span>*</span>
                      未签约天数需要填写限制数量且数量应在 1 到 99999 之间
                    </div>
                  </div>
                </div>
              </section>
            </template>
          </el-form-item>
        </template>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import api from '@/services/api/customRecycle/index.js';

export default {
  props: {
    visible: Boolean,
  },
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
  },
  data() {
    this.nameMap = {
      salesman_rule: '前业务员申请规则',
      customer_count_rule: '客户数量保有规则',
      apply_rate_rule: '申请频率规则',
      recover_rule: '收回规则',
      business_rule: '无新建商机用户',
      visit_rule: '无拜访记录用户',
      contract_rule: '无签约用户',
    };
    return {
      isError: false,
      form: {
        salesman_rule: {
          isLimited: null,
          isBusiness: null,
          isContract: null,
          limitData: null,
        },
        customer_count_rule: {
          isLimited: null,
          isBusiness: null,
          isContract: null,
          limitData: null,
        },
        apply_rate_rule: {
          isLimited: null,
          isBusiness: null,
          isContract: null,
          limitData: null,
        },
        recover_rule: {
          isLimited: null,
          isBusiness: null,
          isContract: null,
          limitData: null,
        },
        visit_rule: {
          isLimited: null,
          isBusiness: null,
          isContract: null,
          limitData: null,
        },
        business_rule: {
          isLimited: null,
          isBusiness: null,
          isContract: null,
          limitData: null,
        },
        contract_rule: {
          isLimited: null,
          isBusiness: null,
          isContract: null,
          limitData: null,
        },
      },
      ruleList: [],
      // 保有量内的三条规则
      list: [],
      offset: 20,
    };
  },
  mounted() {
    this.getRoleList();
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
    }),
  },
  methods: {
    oninput(val) {
      return val ? val.replace(/^\+?[1-9][0-9]*$/, '') : '';
    },
    channelInputLimit(e) {
      const key = e.key;
      // 不允许输入'e'和'.'
      if (key === 'e' || key === '.') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    getRoleList() {
      api.queryRuleList().then((res) => {
        res.data.data.forEach((item) => {
          this.form[item.ruleName] = {
            ...item,
          };

          if (
            ![
              'salesman_rule',
              'customer_count_rule',
              'apply_rate_rule',
              'recover_rule',
            ].includes(item.ruleName)
          ) {
            this.list.push(item);
            if (item.isLimited === 1) {
              this.form['recover_rule'].isLimited = 1;
            }
          }
        });
        this.ruleList = res.data.data;
      });
    },
    checkMax(minVal, maxVal) {
      if (
        !this.isError
        && this.form[minVal].isLimited
        && this.form[maxVal].isLimited
        && Number(this.form[minVal].limitData)
          >= Number(this.form[maxVal].limitData)
      ) {
        this.$message({
          message: `${this.nameMap[minVal]}未访问天数设置需小于${this.nameMap[maxVal]}`,
          type: 'error',
        });
        this.isError = true;
      }
    },
    handleSave() {
      this.isError = false;
      if (!this.auth.highseaRuleSave.toggleStatus) {
        this.$message({
          message: '暂无权限！',
          type: 'error',
        });
        return;
      }
      const ruleList = [];
      Object.keys(this.form).forEach((key) => {
        ruleList.push(this.form[key]);
        if (
          key !== 'recover_rule'
          && this.form[key].isLimited
          && (!this.form[key].limitData || Number(this.form[key].limitData) < 1)
        ) {
          this.$message({
            message: `${this.nameMap[key]}未填写限制数据！`,
            offset: this.offset,
            type: 'error',
          });
          this.offset += 50;
          this.isError = true;
        }
      });

      if (
        !this.isError
        && this.form['recover_rule'].isLimited
        && !this.form['visit_rule'].isLimited
        && !this.form['business_rule'].isLimited
        && !this.form['contract_rule'].isLimited
      ) {
        this.$message({
          message: `${this.nameMap['recover_rule']}未选择设置具体规则！`,
          type: 'error',
        });
        this.isError = true;
      }

      this.checkMax('visit_rule', 'business_rule');
      this.checkMax('visit_rule', 'contract_rule');
      this.checkMax('business_rule', 'contract_rule');

      if (!this.isError) {
        this.$confirm('保存后，将立即生效公海规则，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          api.saveRule({ ruleList }).then(() => {
            this.$message.success('操作成功！');
            this.$emit('success');
            this.$emit('close');
          });
        });
      }
    },
    handleCancel() {
      this.$confirm('当前操作将放弃已编辑内容，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$emit('close');
      });
    },
  },
};
</script>

<style lang="less" scoped>
.input-custom {
  display: flex;
  align-items: center;
  font-size: 12px !important;
  color: #7a84b7;
}
.list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.areaCheck {
  min-width: 608px;
  min-height: 134px;
  border: 1px solid #7a84b7;
  border-radius: 3px;
  .item {
    margin: 0 25px;
    display: flex;
    align-content: center;
    .checkboxs {
      margin-left: 40px;
      display: flex;
      align-content: center;
    }
  }
  .table {
    margin-left: 25px;
  }
  .tip {
    margin-left: 25px;
  }
}
.tip {
  font-size: 12px;
  color: #f56c6c;
}
/deep/.el-checkbox__label {
  color: #7a84b7;
}
/deep/.el-form-item__label {
  font-size: 14px !important;
}
/deep/.el-input {
  width: 100px;
}
</style>
